import { render, staticRenderFns } from "./ZnBaoxiao.vue?vue&type=template&id=6f7d5867&"
import script from "./ZnBaoxiao.vue?vue&type=script&lang=js&"
export * from "./ZnBaoxiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports